import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import {
	Alert,
	Button,
	Form,
	FormControl,
	FormGroup,
	FormLabel,
} from "react-bootstrap";
import Spinner from "react-spinner";
import "react-spinner/react-spinner.css";
import { createShift, settingsPage } from "../../actions";
import { isShiftsFeatureEnabled } from "../../utils/shiftsFeature";

class NewShift extends Component {
	constructor(props) {
		super(props);
		this.state = {
			submitting: false,
			errors: {
				shiftName: false,
				startTime: false,
				endTime: false,
			},
		};
	}

	componentDidMount() {
		if (!this.props.settingsData) {
			this.props.settingsPage(this.props.tvClient);
		}
	}

	componentDidUpdate(prevProps) {
		if (!this.props.settingsData) {
			return;
		}
		if (!isShiftsFeatureEnabled(this.props.settingsData)) {
			if (
				!prevProps.settingsData ||
				isShiftsFeatureEnabled(prevProps.settingsData)
			) {
				this.props.push("/settings");
			}
		}
	}

	submitShift(e) {
		e.preventDefault();
		const name = this.shiftName.value.trim();
		const startVal = this.startTime.value;
		const endVal = this.endTime.value;
		const tz = (this.localTimezone.value || "UTC").trim();
		const loc = this.locationId.value;

		if (!name) {
			this.setState({
				errors: {
					shiftName: true,
					startTime: false,
					endTime: false,
				},
			});
			return;
		}
		if (!startVal) {
			this.setState({
				errors: {
					shiftName: false,
					startTime: true,
					endTime: false,
				},
			});
			return;
		}
		if (!endVal) {
			this.setState({
				errors: {
					shiftName: false,
					startTime: false,
					endTime: true,
				},
			});
			return;
		}

		this.setState({
			errors: {
				shiftName: false,
				startTime: false,
				endTime: false,
			},
		});

		const startTime = new Date(startVal).toISOString();
		const endTime = new Date(endVal).toISOString();
		const locationId = loc === "" ? null : loc;

		this.setState({ submitting: true });
		this.props
				.createShift(
						this.props.tvClient,
						name,
						startTime,
						endTime,
						tz,
						locationId,
				)
				.finally(() => {
						this.setState({ submitting: false });
				});
	}

	render() {
		if (!this.props.settingsData || !isShiftsFeatureEnabled(this.props.settingsData)) {
			return (
				<div>
					<h1 className="page-header">Add New Shift</h1>
					<p>Loading…</p>
				</div>
			);
		}

		let locations = [];
		if (this.props.settingsData && this.props.settingsData.locations) {
				locations = this.props.settingsData.locations;
				if (!Array.isArray(locations)) {
						locations = Object.values(locations);
				}
		}

		return (
			<div>
				<h1 className="page-header">
					Add New Shift
					<small className="backLink">
						(
						<button
							type="button"
							className="simulateAnchor"
							onClick={() => window.history.back()}
						>
							Cancel
						</button>
						)
					</small>
				</h1>

				{this.state.submitting && <Spinner />}

				<Form onSubmit={this.submitShift.bind(this)} className="new-case-form">
					<FormGroup controlId="shiftName">
						<FormLabel>Name *</FormLabel>
						<FormControl
							type="text"
							placeholder="e.g. Day shift"
							ref={(ref) => {
								this.shiftName = ref;
							}}
						/>
						{this.state.errors.shiftName && (
							<Alert variant="danger">Name is required.</Alert>
						)}
					</FormGroup>

					<FormGroup controlId="startTime">
						<FormLabel>Start (local) *</FormLabel>
						<FormControl
							type="datetime-local"
							ref={(ref) => {
								this.startTime = ref;
							}}
						/>
						{this.state.errors.startTime && (
							<Alert variant="danger">Start time is required.</Alert>
						)}
					</FormGroup>

					<FormGroup controlId="endTime">
						<FormLabel>End (local) *</FormLabel>
						<FormControl
							type="datetime-local"
							ref={(ref) => {
								this.endTime = ref;
							}}
						/>
						{this.state.errors.endTime && (
							<Alert variant="danger">End time is required.</Alert>
						)}
					</FormGroup>

					<FormGroup controlId="localTimezone">
						<FormLabel>IANA timezone</FormLabel>
						<FormControl
							type="text"
							placeholder="America/Chicago"
							defaultValue="UTC"
							ref={(ref) => {
								this.localTimezone = ref;
							}}
						/>
						<p>
							<small>
								Used with survey scheduling (e.g. America/New_York, UTC).
							</small>
						</p>
					</FormGroup>

					<FormGroup controlId="locationId">
						<FormLabel>Location (optional)</FormLabel>
						<FormControl
							as="select"
							ref={(ref) => {
								this.locationId = ref;
							}}
						>
							<option value="">All locations</option>
							{locations.map((d) => (
								<option value={d.location_id} key={d.location_id}>
									{d.name}
								</option>
							))}
						</FormControl>
					</FormGroup>

					<FormGroup className="submit-buttons">
						<Button
							type="submit"
							className="float-right"
							disabled={this.state.submitting}
						>
							Add Shift
						</Button>
					</FormGroup>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	tvClient: state.login.tvClient,
	settingsData: state.settingsPage.settingsData,
});

export default connect(mapStateToProps, {
	createShift,
	settingsPage,
	push,
})(NewShift);
